"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    hotelSummaryManager: ()=>hotelSummaryManager
});
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const fetchWithTimeout_js_namespaceObject = require("../utils/fetchWithTimeout.js");
var fetchWithTimeout_js_default = /*#__PURE__*/ __webpack_require__.n(fetchWithTimeout_js_namespaceObject);
const SUMMARY_URL = '/genai-svc/genai/chat/hotelSummary';
async function fetchRequest({ prompts, hotelDetail, source, fetchRequestOptions }) {
    const currentSummary = this;
    try {
        const res = await fetchWithTimeout_js_default()(SUMMARY_URL, {
            method: 'POST',
            body: JSON.stringify({
                prompts,
                hotelDetail,
                productId: 5,
                source
            }),
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Encoding': 'identity',
                ...fetchRequestOptions?.headers
            }
        }, 10000);
        const fullSummaryWords = [];
        if (200 !== res.status) throw new Error(`Unexpected status code: ${res.status} - ${res.statusText || 'No status text'}`);
        if (!res.body || 'function' != typeof res.body.getReader) throw new Error('Response body is not readable');
        const reader = res.body.getReader();
        reader.read().then(async function processStream({ done, value: u8ArrValue }) {
            if (done) {
                const text = fullSummaryWords.join('');
                currentSummary.status = 'DONE';
                currentSummary.text = text;
                return;
            }
            if (u8ArrValue) {
                const value = u8ArrValue.filter((x)=>0 !== x);
                const response = new Response(value);
                const textRes = await response.text();
                fullSummaryWords.push(textRes);
                if (fullSummaryWords?.join('')) currentSummary.text = fullSummaryWords.join('');
            }
            return reader.read().then(processStream);
        }).catch((err)=>{
            analytics_js_default().logError({
                message: 'Failed to parse hotel summary stream',
                error: err.message,
                stack: err.stack,
                loggedFrom: 'generateHotelSummary'
            });
            currentSummary.error = err.message;
            currentSummary.status = 'ERROR';
            currentSummary.text = '';
        });
    } catch (err) {
        analytics_js_default().logError({
            message: 'Failed to fetch hotel summary response',
            error: err.message,
            stack: err.stack,
            loggedFrom: 'generateHotelSummary'
        });
        currentSummary.error = err.message;
        currentSummary.status = 'ERROR';
        currentSummary.text = '';
    }
}
const hotelSummaryManagerinit = ()=>{
    const summaryStore = new Map();
    return {
        addHotelSummary: (hotelName, options)=>{
            if (summaryStore.has(hotelName)) return;
            const summaryInstance = {
                error: '',
                status: 'PENDING',
                text: '',
                fetchRequest
            };
            summaryStore.set(hotelName, summaryInstance);
            summaryInstance.fetchRequest(options).catch((err)=>{
                analytics_js_default().logError({
                    message: 'fetch request failed',
                    error: err.message,
                    stack: err.stack,
                    loggedFrom: 'generateHotelSummary'
                });
            });
        },
        getHotelSummary: (hotelName)=>summaryStore.get(hotelName)
    };
};
const hotelSummaryManager = hotelSummaryManagerinit();
exports.hotelSummaryManager = __webpack_exports__.hotelSummaryManager;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "hotelSummaryManager"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
